import { formatISO } from 'date-fns';

import type { Topic } from './types';

const currentIsoDate = formatISO(new Date());

export const DEFAULT_TOPIC: Topic = {
  createdDate: currentIsoDate,
  lastUpdatedDate: currentIsoDate,
  topic: '...',
  chatId: null,
  isFavorite: false,
};
